var css = css || {};
css.Clase = Class.extend(
    function(){
        /**
         * Clases CSS
         * @type Array
         */
        var thisClasesCss;

        /**
         * Crea un contenedor de clases css
         * @param {css.Clase} cssInicial CSS inicial
         */
        this.constructor = function(cssInicial){
            thisClasesCss = [];
            if(cssInicial)
                this.addClass(cssInicial);
        };

        /**
         * Añade el class css pasado (pueden ser varios separados por espacio o un objeto ClaseCss)
         * @param {(string|css.Clase)} css Clase CSS a añadir
         * @return {css.Clase} Referencia a este objeto
         */
        this.addClass = function(css){
            if(css){
                var cs = css.toString().split(" ");
                for(var c in cs){
                    if(cs[c]!="")
                        thisClasesCss[cs[c]] = true;
                }
            }
            return this;
        };

        /**
         * Elimina el class css pasado (pueden ser varios separados por espacio o un objeto ClaseCss)
         * @param {(string|css.Clase)} css Clase CSS a eliminar
         * @return {css.Clase} Referencia a este objeto
         */
        this.removeClass = function(css){
            var cs = css.toString().split(" ");
            for(var c in cs)
                delete thisClasesCss[cs[c]];
            return this;
        };

        /**
         * Determina si tiene el class css pasado
         * @param {string} nombreClaseCss Clase CSS a comprobar
         * @return {bool} True si tiene el class, false en caso contrario
         */
        this.hasClass = function(nombreClaseCss){
            return (thisClasesCss[nombreClaseCss]?true:false);
        };

        this.toString = function(){
            var lista = [];
            for(var c in thisClasesCss)
                lista.push(c);
            return lista.join(" ");
        };
    }
);
